module.exports = __webpack_public_path__ + "static/media/Optimus Privacy Policy.3f1e8b16.pdf";